import React, {Component} from "react" ;
import Body from "./Body";
import Header from "./Header";
import Footer from "./Footer";
import ReactLoading from "react-loading";

class Table extends Component {
	constructor(props) {
		super(props);
		this.state = {
			paginationEnabled: true,
		};
		this.orderBy = this.orderBy.bind(this);
		this.pageSize = this.pageSize.bind(this);
	}

	componentWillMount() {
		if (this.props.paginationEnabled === undefined) {
			this.setState({paginationEnabled: true})
		} else {
			this.setState({paginationEnabled: this.props.paginationEnabled})
		}
		this.setState({page: this.props.page, size: this.props.size});

		if (!!this.props.fetchData)
			this.props.fetchData(undefined, undefined, this.props.page, this.props.size);


	}

	orderBy(accessor, direction) {
		this.setState({accessor: accessor, direction: direction});
		if (!!this.props.fetchData)
			this.props.fetchData(accessor, direction, this.state.page, this.state.size);
	}

	pageSize(page, size) {
		this.setState({page: page, size: size});
		if (!!this.props.fetchData)
			this.props.fetchData(this.state.accessor, this.state.direction, page, size);

	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.manual === true && !!this.props.fetchData) {
			this.setState({page: nextProps.page, size: nextProps.size});
			this.props.fetchData(this.state.accessor, this.state.direction, nextProps.page, nextProps.size);
		}
	}

	render() {
		return (
			<table style={this.props.style}>
				<Header columns={this.props.columns} orderBy={this.orderBy}/>
				{this.props.loading
					?  (<tbody>
							<tr>
								<td colSpan={this.props.columns.length}>{this.props.loadingText ? this.props.loadingText :
									<ReactLoading type="spinningBubbles" style={{width:"70px", height: "70px", margin: "20px auto 0 auto", fill: "#888"}}/>}</td>
							</tr>
						</tbody>)
					:
					<Body
						columns={this.props.columns}
						items={this.props.content}
						emptyMessage={this.props.emptyMessage || "Kayıt bulunamadı."}
						getTrStyles={this.props.getTrStyles}
						getTrClass={this.props.getTrClass}
					/>
				}
				{this.state.paginationEnabled && <Footer total={this.props.total}
						length={this.props.columns.length}
						pageSize={this.pageSize}
						options={this.props.options}
						page={this.props.page}
						size={this.state.size}
						hide={this.state.paginationEnabled}
				/>}
			</table>
		);
	}
}

export default Table;


// WEBPACK FOOTER //
// ./src/components/Table/Table.js